module.exports = __webpack_public_path__ + "img/Datadog.01dfe32.svg";